import {
    GET_EMPLOYEE_ROLES_REQUESTED,
    GET_EMPLOYEE_ROLES_SUCCEEDED,
    GET_EMPLOYEE_ROLES_FAILED,
    CREATE_EMPLOYEE_ROLE_REQUESTED,
    CREATE_EMPLOYEE_ROLE_SUCCEEDED,
    CREATE_EMPLOYEE_ROLE_FAILED,
    UPDATE_EMPLOYEE_ROLE_REQUESTED,
    UPDATE_EMPLOYEE_ROLE_SUCCEEDED,
    UPDATE_EMPLOYEE_ROLE_FAILED,
} from './constants'
import api from '../../utils/api'

export const getEmployeeRolesRequested = () => ({
  type: GET_EMPLOYEE_ROLES_REQUESTED
})

export const getEmployeeRolesSucceeded = (payload) => ({
  type: GET_EMPLOYEE_ROLES_SUCCEEDED,
  payload,
})

export const getEmployeeRolesFailed = () => ({
  type: GET_EMPLOYEE_ROLES_FAILED
})

export const createEmployeeRoleRequested = () => ({
  type: CREATE_EMPLOYEE_ROLE_REQUESTED
})

export const createEmployeeRoleSucceeded= (payload) => ({
  type: CREATE_EMPLOYEE_ROLE_SUCCEEDED,
  payload,
})

export const createEmployeeRoleFailed = () => ({
  type: CREATE_EMPLOYEE_ROLE_FAILED
})

export const updateEmployeeRoleRequested = () => ({
  type: UPDATE_EMPLOYEE_ROLE_REQUESTED
})

export const updateEmployeeRoleSucceeded= (payload) => ({
  type: UPDATE_EMPLOYEE_ROLE_SUCCEEDED,
  payload,
})

export const updateEmployeeRoleFailed = () => ({
  type: UPDATE_EMPLOYEE_ROLE_FAILED
})


export const fetchEmployeeRoles = (venueUuid, employeeId, salesEventId) => dispatch => {
  dispatch(getEmployeeRolesRequested())

  return api
    .fetchEmployeeRoles(venueUuid, employeeId, salesEventId)
    .then(response => dispatch(getEmployeeRolesSucceeded(response?.data?.employeeRoles)))
    .catch(err => dispatch(getEmployeeRolesFailed(err)))
}

export const createEmployeeRole = (data) => dispatch => {
  dispatch(createEmployeeRoleRequested())

  return api
    .createEmployeeRole(data)
    .then(response => dispatch(createEmployeeRoleSucceeded(response?.data)))
    .catch((err) => dispatch(createEmployeeRoleFailed(err)))
}

export const updateEmployeeRole = (data, deleteId) => dispatch => {
  dispatch(updateEmployeeRoleRequested())

  return api
    .deleteEmployeeRole(deleteId)
    .then(response => dispatch(createEmployeeRole(data)))
    .catch((err) => dispatch(updateEmployeeRoleFailed(err)))
}
